<template>
  <select
    class="tournament-result-select"
    v-model="selectedResult"
    @click.prevent.stop=""
  >
    <option
      v-for="option in filteredOptions"
      :key="`${boardNumber}-${color}-${option.value}`"
      :value="option.value"
      class="has-background-success"
    >
      {{ option.displayText }}
    </option>
  </select>
</template>

<script>
import {
  TOURNAMENT_GAME_RESULT_TEXT,
  TOURNAMENT_GAME_RESULT_SCORE,
  TOURNAMENT_GAME_RESULT,
} from "vue-chess-shared/constants";

export default {
  name: "TournamentResultSelect",
  props: {
    result: {
      type: Number,
      default: TOURNAMENT_GAME_RESULT.UNFINISHED,
    },
    boardNumber: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: true,
      validator: (value) => ["white", "black"].includes(value),
    },
    isTwoPlayerMatch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tournamentResultText: TOURNAMENT_GAME_RESULT_TEXT,
      tournamentResultScore: TOURNAMENT_GAME_RESULT_SCORE,
    };
  },

  computed: {
    selectedResult: {
      get() {
        return this.result;
      },
      set(value) {
        this.$emit("update:result", value);
      },
    },

    filteredOptions() {
      const possibleResults = this.isTwoPlayerMatch
        ? [
            TOURNAMENT_GAME_RESULT.UNFINISHED,
            TOURNAMENT_GAME_RESULT.WIN,
            TOURNAMENT_GAME_RESULT.LOSS,
            TOURNAMENT_GAME_RESULT.DRAW,
            TOURNAMENT_GAME_RESULT.FORFEITW,
            TOURNAMENT_GAME_RESULT.FORFEITL,
            TOURNAMENT_GAME_RESULT.FORFEITD,
            TOURNAMENT_GAME_RESULT.DISQUALIFIED,
          ]
        : [
            TOURNAMENT_GAME_RESULT.PAIRINGBYE,
            TOURNAMENT_GAME_RESULT.FULLBYE,
            TOURNAMENT_GAME_RESULT.ZEROBYE,
            TOURNAMENT_GAME_RESULT.HALFBYE,
            TOURNAMENT_GAME_RESULT.DISQUALIFIED,
          ];
      return possibleResults.map((result) => ({
        value: result,
        text: this.tournamentResultText[result],
        score: this.tournamentResultScore[result],
        displayText:
          this.tournamentResultText[result] +
          (this.tournamentResultScore[result] === null
            ? ""
            : " +" +
              (this.tournamentResultScore[result] === 0.5
                ? "½"
                : this.tournamentResultScore[result])),
      }));
    },
  },
};
</script>

<style scoped>
.tournament-result-select {
  margin: 0.25rem;
  min-width: 100px;
}
</style>
